import type { FeatureBundle } from 'motion/react';
import { useEffect } from 'react';

let release = (): void => {};
const wanted = new Promise<void>((resolve) => {
  release = resolve;
});

export const wantMotion = (): void => release();

export const loadMotion = (): Promise<FeatureBundle> =>
  wanted.then(() => import('@/motionFeatures')).then((mod) => mod.default);

export function useMotion(): void {
  useEffect(wantMotion, []);
}
